export function spotFavourites() {
  
  // my favourites
  const favouriteList = document.getElementById('favouriteList');
  const btnAddToFavourites = document.querySelectorAll('.btn-add-to-favourites');
  const allFavButtons = document.getElementsByClassName('favourite-icon');
  
  for (let index = 0; index < allFavButtons.length; index++) {
    const button = allFavButtons[index];
    if (checkIfItemExists(button.dataset.id)) {
      if(button['children'][0].classList.contains("far")){
        button['children'][0].classList.replace("far", "fas");
      }
    }else {
      if(button['children'][0].classList.contains("far")){
        button['children'][0].classList.replace("fas", "far");
      }
    }
  }
  

  addStorageToList();
  deleteSingleEvent();
  if(btnAddToFavourites) {
    btnAddToFavourites.forEach(function(button){
      button.addEventListener('click', function() {
        const icon = this.getElementsByTagName('svg');
        if(icon[0].dataset.prefix == "fas"){
          icon[0].dataset.prefix = "far";
          removeItemFromLocalStorage(button.dataset.id);
          removeItemFromList(button.dataset.id);
        }else {
          icon[0].dataset.prefix = "fas";
          if(!checkIfItemExists(button.dataset.id)) {
            addItemToLocalStorage(button.dataset.title, button.dataset.id, button.dataset.url, button.dataset.type, button.dataset.date);
            addItemToList(button.dataset.title, button.dataset.id, button.dataset.url, button.dataset.type, button.dataset.date);
            deleteSingleEvent();
          }
        }
        updateFavCounter();
      });
    });
  }

  function updateFavCounter() {
    let locCounter = localStorage.length;
    let favCounter = document.getElementById('favcounter');
    if(favCounter) {
      favCounter.innerHTML = locCounter;
    }
  }
  updateFavCounter();


  // Check button status

  function checkButtonStatus(id, button) {
    let icon = button.querySelector('#bookmark-icon');
    if (checkIfItemExists(id)) {
      if(icon[0].dataset.prefix == "far"){
        icon[0].dataset.prefix = "fas";
      }
    }else {
      if(icon.dataset.prefix == "fas"){
        icon.dataset.prefix = "far";
      }
    }
  }

  // Delete my favourites

  const btnDeleteMyFavourites = document.getElementById('deleteMyFavourites');
  if(btnDeleteMyFavourites){
    btnDeleteMyFavourites.addEventListener('click', function(){
      localStorage.clear();
      favouriteList.innerHTML = "";
      btnAddToFavourites.forEach(function(button){
        checkButtonStatus(button.dataset.id, button);
      });
      updateFavCounter();
    });
  }

  function addItemToList(title, id, url, type, date) {
    let li = document.createElement('li')
    li.id = id
    li.setAttribute('data-type', type);
    li.setAttribute('data-eventdate', date);
    li.setAttribute('data-id', id);
    li.classList.add("list-group-item", "d-flex", "justify-content-between");
    let icon;
    let subtitle;
    if(type == 'event'){
      icon = 'fa-calendar-star';
      subtitle = date + ' Uhr';
    }else if(type == 'post') {
      icon = 'fa-newspaper';
      subtitle = 'Magazinartikel';
    }else {
      icon = 'fa-map-marker-alt';
    }
    let newFavourite = '<span><i class="fal ' + icon + '"></i><strong class="pl-3"><small>' + subtitle + '</small></strong><br><a href="' + url + '">' + title + '</a></span> <button data-id=' + id + ' class="deleteSingleEvent btn btn-link p-0"><i class="fal fa-times-circle"></i></button>';
    li.innerHTML = newFavourite;
    if(favouriteList) {
      favouriteList.appendChild(li);
    }
  }

  function addItemToLocalStorage(title, id, url, type, date) {
    var event = [type, url, title, date];
    localStorage.setItem('"' + id + '"', JSON.stringify(event));
  }

  function removeItemFromLocalStorage(id) {
    localStorage.removeItem('"' + id + '"');
  }
  
  function addStorageToList() {
    return false;

    // if(localStorage) {
    //   Object.keys(localStorage).forEach(function(key){
    //     let item = JSON.parse(localStorage.getItem(key));
    //     let id = key.slice(1, -1);
    //     addItemToList(item[2], id, item[1], item[0], item[3]);
    //  });
    // }
  }
  

  
  // Check FavList for expired events
  function checkExpiredEvents(date, id) {
    let eventDate = Date.parse(date);
    var now = new Date();
    now.setDate(now.getDate()-1);
    if(eventDate <= now) {
      removeItemFromLocalStorage(id);
      removeItemFromList(id);
      btnAddToFavourites.forEach(function(button){
        checkButtonStatus(id, button);
      });
      updateFavCounter();
    }
  }

  if(favouriteList){
    for (let index = 0; index < favouriteList.children.length; index++) {
      const element = favouriteList.children[index];
      if(element.dataset.type == 'event'){
        checkExpiredEvents(element.dataset.eventdate, element.dataset.id);
      }
    }
  }

  function deleteSingleEvent() {
    var deleteSingleEvent = document.getElementsByClassName('deleteSingleEvent');
    for (let index = 0; index < deleteSingleEvent.length; index++) {
      let button = deleteSingleEvent[index];
      button.addEventListener('click', function() {
        var eventId = this.dataset.id;
        removeItemFromLocalStorage(eventId);
        removeItemFromList(eventId);
        updateFavCounter();
        btnAddToFavourites.forEach(function(button){
          checkButtonStatus(eventId, button);
        });
      });
    }
  }

  function removeItemFromList(id) {
    let removeLiItem = document.getElementById(id);
    removeLiItem.remove();
  }

  function checkIfItemExists (id) {
    const item = localStorage.getItem('"' + id + '"')
    let itemExists = false
    if (item) {
      let itemExists = true
      return itemExists
    }else {
      return itemExists
    }
  }
}


// WEBPACK FOOTER //
// ./scripts/components/favourite.js